export default {
  // huBbox(state) {
  //   return state.countries.paths.find(o => o.id === 'HU').bbox;
  // },
  availableCountries(state) {
    return state.countries.details.map(data => data.cId);
  },
  getCIdById(state) {
    return id => {
      const cObj = state.countries.details.find(o => o.id === id);
      if (cObj) {
        return cObj.cId;
      } else {
        return undefined;
      }
    };
  },
  getIdByCId(state) {
    return cId => {
      const cObj = state.countries.details.find(o => o.cId === cId);
      if (cObj) {
        return cObj.id;
      } else {
        return undefined;
      }
    };
  },
  getActiveCountryId(state) {
    return state?.countries?.activeCountryId;
  },
  getCountryDetailById(state) {
    const {
      countries: { details }
    } = state;
    return id => {
      return details.find(o => id === o.id);
    };
  },
  getActiveCountryDetail(state) {
    const {
      countries: { details, activeCountryId }
    } = state;

    if (!activeCountryId) return null;

    return details.find(o => o.id === activeCountryId);
  },
  getProjectileToHuById(state) {
    const {
      countries: { projectileToHu }
    } = state;
    return cId => {
      return projectileToHu.find(o => o.id === cId);
    };
  },
  currentZoom(state) {
    return state.svg?.currentZoom;
  },
  zoom(state) {
    return Math.floor(state.svg?.currentZoom / state.svg?.minZoom);
  },
  minZoom(state) {
    return state.svg?.minZoom;
  },
  maxZoom(state) {
    return state.svg?.maxZoom;
  }
};
